import request from './api/api';

export const actions = {
  get_list: 'GET_OCCUPATION_LIST',
};

export function getOccupations() {
  return request(actions.get_list, '/occupations', 'GET', {}, []);
}

const INITIAL_STATE = { list: [] };

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.get_list:
      return { ...state, list: action.body ? action.body.result : [] };
    default:
      return { ...state };
  }
}
